import dayjs from "../../../utils/dayjs";
import { Alert, Form } from "antd";
import React from "react";

export const DurationHourChecker = ({ keys }) => {
  // if (dataForm?.[keys[0]] === undefined || dataForm?.[keys[1]] === undefined) {
  //   return <></>;
  // }

  const start = Form.useWatch(keys[0]);
  const end = Form.useWatch(keys[1]);

  if (start === undefined || end === undefined) {
    return <></>;
  }

  const durationMinutes = end.diff(start, "minute");

  // Calculate hours and remaining minutes
  const durationHours = Math.floor(durationMinutes / 60);
  const remainingMinutes = durationMinutes % 60;

  // Function to handle pluralization
  const pluralize = (count, singular, plural) =>
    count <= 1 ? singular : plural;

  // Check if the duration is more than 12 hours (720 minutes) or less than 1 hour (60 minutes)
  if (durationMinutes >= 720) {
    const description = (
      <span>
        La durée de la prestation est de{" "}
        <b>
          {durationHours} {pluralize(durationHours, "heure", "heures")}
        </b>
        {remainingMinutes > 0 ? (
          <>
            {" "}
            et{" "}
            <b>
              {remainingMinutes}{" "}
              {pluralize(remainingMinutes, "minute", "minutes")}
            </b>
          </>
        ) : (
          ""
        )}
      </span>
    );

    const lessOneMinute = (
      <span>
        La durée de la prestation est de <b>moins d'une minute.</b>
      </span>
    );

    return (
      <Alert
        key={durationMinutes}
        style={{ width: "100%" }}
        message={`La date / heure de fin de cette prestation semble erronée, vous devriez vérifier votre saisie.`}
        description={
          durationMinutes === 0 && durationHours <= 0
            ? lessOneMinute
            : description
        }
        type="error"
        showIcon
        closable={true}
      />
    );
  } else if (durationMinutes < 0) {
    return (
      <Alert
        key={durationMinutes}
        style={{ width: "100%" }}
        message={`La date / heure de fin de cette prestation semble erronée, vous devriez vérifier votre saisie.`}
        type="error"
        showIcon
        closable={true}
      />
    );
  } else {
    return null;
  }
};
